import { useQuery } from "@tanstack/react-query";
import { getFeaturedPosts } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch featured blog posts
 * @param {Object} params - Query parameters
 * @param {number} params.limit - Number of posts (default: 5)
 */
export function useGetFeaturedPosts(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["featuredPosts", i18next.language, params],
        queryFn: () => getFeaturedPosts(params),
        retry: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        cacheTime: 1000 * 60 * 10, // 10 minutes
    });

    const posts = data?.data?.data || [];

    return { isLoading, error, posts, refetch };
}
